import { varGlobal } from "../shared/varGlobal";
import { Injectable } from "@angular/core";
import { AppSettingsService } from "./appsettings.service";
import { IntlService } from "@progress/kendo-angular-intl";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { HttpClient } from "@angular/common/http";

/**
 *  Service de gestion des Commandes HB
 */
@Injectable()
export class SyntheticdespatchadviceService extends BehaviorSubject<any[]> {
  /** Chemin vers l'API */
  public w_baseUrl: string = "";

  /**
   * Constructeur
   */
  constructor(
    public http: HttpClient,
    public s_appsettings: AppSettingsService,
    public s_global: varGlobal,
    public s_intl: IntlService
  ) {
    super([]);
    this.w_baseUrl = this.s_global.pathAPI + "/syntheticDEA";
  }

  /** Data suivante */
  public proc_next(data) {
    if (data != null) super.next(data);
    else super.next([]);
  }

  /**
   * Fonction de recuperation des Commandes
   */
  public proc_getHBSyntheticDespatchAdvice(
    i_tiers: number,
    d_start: Date,
    d_end: Date,
    state: any
  ): Observable<any> {
    const w_start: string = this.s_intl.formatDate(d_start, "yyyy-MM-dd");
    const w_end: string = this.s_intl.formatDate(d_end, "yyyy-MM-dd");

    let w_sort_column = "";
    if (state.sort[0] != null) w_sort_column = state.sort[0].field;

    return this.http.post(
      `${this.w_baseUrl}/getHBSyntheticDespatchAdvice`,
      JSON.stringify({
        tiersId: i_tiers,
        dateMin: w_start,
        dateMax: w_end,
        start: state.skip,
        rows: state.take,
        sort_column: w_sort_column
      }),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation d'un blob d'avis
   */
  public proc_getHBDeaBlob(
    i_tiers: number,
    w_msgId: number,
    f_fVisuBlob: boolean,
    w_urlClient: string
  ): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/getHBDeaBlob`,
      JSON.stringify({
        tiersId: i_tiers,
        msgId: w_msgId,
        fVisuBlob: f_fVisuBlob,
        urlClient: w_urlClient
      }),
      this.s_appsettings.proc_getHeaders()
    );
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/syntheticdespatchAdvice.service.ts